var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"file-wrap"},[_c('div',{staticClass:"text-wrap",class:[_vm.isMax ? 'web-wrap-max' : 'web-wrap'],domProps:{"innerHTML":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }